import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

const StyledBackground = styled.div<{ backgroundImageUrl?: string }>`
  width: 100%;
  height: 14rem;
  position: absolute;
  top: 0;
  background-color: ${primitive.bk.$flamingOrange};

  ${Styles.desktop`
    top: unset;
    margin-top: 34px;
    height: 32vh;
  `}
`;

export default StyledBackground;
